import utils from './utils';

import carousel from './components/carousel';
import menu from './components/menu';
import imgtosvg from './components/imgtosvg';
import lazyload from './components/lazy-load';
import accordion from './components/accordion';
import modals from './components/modals';
import nmrdCarousel from './components/numbered-carousel';
import animations from './components/entry-animations';
import undelines from './project-components/animated-lines';
// import mouse from './components/magicmouse';
// import particles from './components/particles';

function initHiPriorityCommon() {
    imgtosvg.initImgtosvg();
	lazyload.init();
}

function initLowPriorityCommon() {
    setTimeout(function() {
        
    }, 1000);
}

function initPage() {
    carousel.initCarousel();
    menu.initMenu();
    accordion.init();
    modals.init();
    nmrdCarousel.initNumberedCarousel();
    animations.initEntryAnimations();
    undelines.SmxRenderLineMarks();
    // mouse.initMouse();
    //  particles.initParticles();
}

// document.addEventListener( 'DOMContentLoaded', function () {
utils.domReady(function () {
	initHiPriorityCommon();
	initPage(); 
	initLowPriorityCommon();
});

window.addEventListener('load', function () {
    //loadScript('https://cdn.iubenda.com/iubenda.js', false, null);
    //injectsmxConsole();
});